export const FEMALE = { id: 'female', label: 'Femminili' };
export const MALE = { id: 'male', label: 'Maschili' };
export const INDETERMINATE = { id: 'indeterminate', label: 'Indeterminati' };
